import { GetterTree } from 'vuex'
import { ConsumingDeviceState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ConsumingDeviceState, RootState> = {
}
